<template>
  <div class="content" id="password">
    <div class="news">
      <div class="locate">
        <p>当前位置 > 找回密码</p>
      </div>
      <el-divider></el-divider>
      <div class="detail">
        <el-form ref="form" :rules="rules" :model="form">
          <el-row style="margin-bottom: 15px">
            <el-col :span="8" align="left"> 请填写您需要找回的帐号信息 </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" align="left">
              <el-form-item label="" prop="loginAccount">
                <el-input
                  placeholder="请输入证件号或手机号码"
                  v-model="form.loginAccount"
                  :disabled="isVerifyed"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="isVerifyed == false">
            <el-col :span="8" align="left">
              <el-form-item label="" prop="vCode">
                <div
                  style="
                    display: flex;
                    flex-shrink: 0;
                    margin: 10px 0 0 0;
                    width: 100%;
                    height: 50px;
                    position: relative;
                    box-sizing: border-box;
                  "
                >
                  <el-input
                    placeholder="随机验证码"
                    v-model="form.vCode"
                    style="width: 75%"
                  ></el-input>
                  <canvas
                    id="vCaptcha"
                    ref="vCaptcha"
                    width="100"
                    height="50"
                    @click="genarateCode"
                    style="border: 1px solid #ccc; border-radius: 5px"
                  ></canvas>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 15px" v-if="isVerifyed == true">
            <el-col :span="8" align="left"> 请填写新的密码 </el-col>
          </el-row>
          <el-row v-if="isVerifyed == true">
              <el-col :span="8" align="left">
                <el-form-item prop="password">
                  <el-input v-model="form.password" show-password placeholder="请填写新的密码"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 15px" v-if="isVerifyed == true">
                <el-col :span="8" align="left"> 请确认密码 </el-col>
            </el-row>
            <el-row v-if="isVerifyed == true">
              <el-col :span="8" align="left">
                <el-form-item prop="confirmPassword">
                  <el-input v-model="form.confirmPassword" show-password placeholder="请确认密码"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          <el-row>
            <el-col :span="8" align="center">
              <el-button v-if="isVerifyed == false" type="primary" @click="next()" style="width: 100%">下一步</el-button>
              <el-button v-else type="primary" @click="submit()" style="width: 100%">确定</el-button>
            </el-col>
          </el-row>
        </el-form>

        <!--下一步后，弹出手机验证-->
        <el-dialog
          title="安全验证"
          :visible.sync="verifyDialogShow"
          width="30%"
          :center="false"
          top="20vh"
          :close-on-click-modal="false"
        >
          <el-form :model="form">
            <el-row style="margin-bottom: 15px">
              <el-col align="left">
                您的账号正在重置密码，为保障账号安全，重置前需验证身份
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" align="left">
                <el-form-item>
                  <el-select v-model="form.mobile" style="width: 100%">
                    <el-option
                      v-for="item in mobileList"
                      :key="item.no"
                      :value="item.no"
                      :label="item.showText"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item prop="msgCode">
                  <p class="input-item">
                    <el-input
                      placeholder="请输入短信验证码"
                      v-model="form.msgCode"
                      style="width: 75%; height: 50px"
                    ></el-input>
                    <el-button
                      v-if="messageCoolDown > 0"
                      size="small"
                      type="primary"
                      disabled
                      style="height: 50px; width: 25%; font-size: 14px"
                      >({{ messageCoolDown }})秒</el-button
                    >
                    <el-button
                      v-else
                      size="small"
                      type="primary"
                      @click="sendVCode()"
                      style="height: 50px; width: 25%"
                      >发送验证码</el-button
                    >
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-button type="primary" style="width: 100%" @click="confirm()">确 定</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import UserApi from '@/api/user/index'
import { drawCaptcha } from "@/helper/utils";
import { isMobile } from "@/helper/validate";
import CryptoJS from "crypto-js";
export default {
  inject: ["reload"],
  data() {
    return {
      form: {
        loginAccount: "",
        mobile: "",
        password: "",
        confirmPassword: "",
        vCode: "",
        msgCode: "",
      },
      mobileList: [],
      shownum: [],
      messageCoolDown: 0,
      verifyDialogShow: false,
      isVerifyed: false,
      rules: {
        loginAccount: [
          { required: true, message: "请填写证件号或手机号码", trigger: "blur" },
        ],
        vCode: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
                if(this.isVerifyed == false){
                    let num = this.shownum.join("").toLowerCase();
                    if (!value) {
                        callback(new Error("请您输入验证码"));
                    } else if (value.toLowerCase() != num) {
                        callback(new Error("验证码输入不正确"));
                    } else {
                        callback();
                    }
                }
                else{
                    callback();
                }
            },
            trigger: "blur",
          },
        ],
        msgCode: [
          { required: true, message: "请您输入短信验证码", trigger: "blur" },
        ],
        password: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("密码不可为空"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            type: "String",
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("确认密码不可为空"));
              } else if (value != this.form.password) {
                callback(new Error("两次输入密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    // 下一步
    next: function () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // 获取安全验证所需的号码信息
          UserApi.getRestPwdVerifyInfo(this.form.loginAccount)
          .then(res=>{
            this.mobileList = res.data;
            if(this.mobileList.length>0){
                this.form.mobile = 1;
            }

            // 弹出安全验证的框
            this.verifyDialogShow = true;
          }).catch(()=>{
            this.$message({
                message: "未获取到此账号信息，请重新输入",
                type: "error",
            });
          });          
        }
      });
    },
    // 验证确定
    confirm:function(){
        var mobileNo = this.form.mobile;
        this.mobileList.forEach(function (ele) {
            if (ele.no == mobileNo) {
            mobileNo = ele.mobileNo;
            }
        });
        UserApi.checkMsgVerifyCode({mobile: mobileNo, msgCode: this.form.msgCode})
        .then(res=>{
            if(res.success){
                if(res.data){
                    // 关闭Dialog，显示密码输入
                    this.verifyDialogShow = false;
                    this.isVerifyed = true;
                }
                else{
                    this.$message({
                        message: "手机验证码不正确",
                        type: "error",
                    });
                }
            }
        }).catch(()=>{
            this.$message({
                message: "手机验证码验证失败，请重试",
                type: "error",
            });
        });
    },
    submit:function(){
        this.$refs["form"].validate((valid) => {
            if (valid) {
                var userAccount = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.form.loginAccount), CryptoJS.enc.Utf8.parse("1234567890ABCDEF"),{mode:CryptoJS.mode.ECB,padding:CryptoJS.pad.Pkcs7}).ciphertext.toString().toUpperCase();
                var password = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.form.password), CryptoJS.enc.Utf8.parse("1234567890ABCDEF"),{mode:CryptoJS.mode.ECB,padding:CryptoJS.pad.Pkcs7}).ciphertext.toString().toUpperCase();
                // 提交密码修改申请
                UserApi.resetPassword({userAccount: userAccount, password: password})
                .then(res=>{
                    if(res.success){
                        this.$message({
                            message: "密码重置成功，请使用新密码登陆系统",
                            type: "success",
                        });

                        this.reload();
                    }
                }).catch(()=>{
                    this.$message({
                        message: "密码重置失败，请重试",
                        type: "error",
                    });
                });
            }
        });
    },
    // 生成验证码
    genarateCode() {
      drawCaptcha(this.shownum, this.$refs.vCaptcha);
    },
    // 发送短信验证码
    sendVCode() {
      // 发送手机验证码
      var mobileNo = this.form.mobile;
      this.mobileList.forEach(function (ele) {
        if (ele.no == mobileNo) {
          mobileNo = ele.mobileNo;
        }
      });

      if (!mobileNo || !isMobile(mobileNo)) {
        this.$message({ message: "请填写正确的手机号码！", type: "error" });
        return;
      }

      UserApi.sendVerifyCode({
        mobile: mobileNo,
        codeType: 3,
      }).then(
        (res) => {
          if (res.success) {
            this.messageCoolDown = 60;
            var vue = this;
            var inter1 = setInterval(function () {
              vue.messageCoolDown = vue.messageCoolDown - 1;
              localStorage.setItem(
                "jdwx_resetMessageCoolDown",
                vue.messageCoolDown
              );
              if (vue.messageCoolDown === 0) {
                clearInterval(inter1);
              }
            }, 1000);
          }
        },
        (reason) => {
          if (reason) {
            this.$message({
              message: reason,
              type: "error",
            });
          }
        }
      );
    },
    // 初始化
    init:function(){
        this.form.loginAccount = "";
        this.form.mobile = "";
        this.form.msgCode = "";
        this.form.vCode = "";
        this.form.password = "";
        this.form.confirmPassword = "";
        this.isVerifyed = false;
        this.verifyDialogShow = false;
        this.$refs["form"].clearValidate();
    }
  },
  activated: function () {
      this.init();
  },
  mounted: function () {
      this.init();
    var vm = this;
    setTimeout(function () {
      drawCaptcha(vm.shownum, vm.$refs.vCaptcha);
    }, 300);
  },
};
</script>

<style lang="less" scoped>
#password {
  .news {
    width: 1176px;
    height: auto;
    margin: 41px auto;
    display: block;
  }

  .news .locate {
    padding-top: 27px;
    width: 270px;
    height: 15px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    text-align: left;
  }

  .detail {
    margin-top: 46px;
    text-align: center;
  }

  .title {
    height: 30px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #2c2c2c;
    line-height: 48px;
  }

  .mainInfo1,
  .mainInfo2 {
    text-align: left;
    margin-top: 34px;
    font-size: 16px;
    font-weight: 400;
    color: #343434;
    line-height: 48px;
    text-indent: 2em;
  }

  .mainInfo2 {
    text-align: left;
    text-indent: 0;
  }

  .el-input /deep/ .el-input__inner {
    height: 50px;
  }
}
</style>